import type { IconSvgObject } from './types';

const LessThanOrEqualIcon: IconSvgObject = [
  ["path", { d: "M19 4.5L8.85391 7.58595C6.28464 8.3674 5 8.75812 5 9.5C5 10.2419 6.28464 10.6326 8.85391 11.414L19 14.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M5 15L19 19.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default LessThanOrEqualIcon;
